import { FC } from "react"

import { Stack } from "@mui/material"
import mixpanel from "mixpanel-browser"
import { useTranslation } from "react-i18next"
import { useNavigate } from "react-router-dom"
import { RoutePath } from "routes/Route.types"

interface IProps {
  classId: string
  isGroups: boolean
  studentsPath: RoutePath
  groupsPath: RoutePath
}

const SEGMENTS: { key: "students" | "groups"; labelKey: string }[] = [
  { key: "students", labelKey: "layout.students" },
  { key: "groups", labelKey: "layout.groups" },
]

const StudentsGroupsSwitch: FC<IProps> = ({
  classId,
  isGroups,
  studentsPath,
  groupsPath,
}) => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  const go = (key: "students" | "groups") => {
    const isTargetGroups = key === "groups"
    if (isTargetGroups === isGroups) return
    mixpanel.track("main_head_tab", { event_name: key })
    navigate(
      (isTargetGroups ? groupsPath : studentsPath).replace(":classId", classId),
    )
  }

  return (
    <Stack
      direction="row"
      alignSelf="center"
      p="6px"
      mb={{ mobile: "12px", tablet: "16px" }}
      borderRadius="999px"
      bgcolor="mockup.primary95"
    >
      {SEGMENTS.map(({ key, labelKey }) => {
        const isActive = key === "groups" ? isGroups : !isGroups
        return (
          <Stack
            key={key}
            component="button"
            type="button"
            onClick={() => go(key)}
            aria-pressed={isActive}
            px="28px"
            py="10px"
            borderRadius="999px"
            sx={{
              border: "none",
              cursor: "pointer",
              fontWeight: 600,
              fontSize: "16px",
              color: isActive ? "mockup.neutral0" : "mockup.neutral40",
              bgcolor: isActive ? "common.white" : "transparent",
              transition: "background-color 0.15s",
            }}
          >
            {t(labelKey)}
          </Stack>
        )
      })}
    </Stack>
  )
}

export default StudentsGroupsSwitch
